import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { PesapalService } from 'src/app/services/pesapal.service';

@Component({
  selector: 'app-pesapal-webhook',
  templateUrl: './pesapal-webhook.component.html',
  styleUrls: ['./pesapal-webhook.component.css']
})
export class PesapalWebhookComponent implements OnInit {

  src?:SafeResourceUrl
  loading = true
  constructor(private pesapalSvc: PesapalService,private route:ActivatedRoute,private sanitizer:DomSanitizer) { }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      
      const token = params['token']
      this.pesapalSvc.getPesapalUrl({token}).subscribe(
        {
          next:(res) => {
            if(res.error){

            }
            else {
              this.src = this.sanitizer.bypassSecurityTrustResourceUrl(res.url)
              
              this.loading= false
            }
        },
        error: err => console.log(err)
      }
        
        )
    })
  }

}
